<template>
  <div
    v-if="imageContainerId"
    :class="`rotate-button-container ${controlSize}`"
  >
    <div class="nopads" style="width: 1.7em !important;"/>
    <div class="rotate-button" @click.stop="rotateRight">
      <font-awesome-icon icon="repeat" :title="$t('common.rotate')"/>
    </div>
    <div
      v-if="showDeleteButton"
      class="rotate-button"
      @click.stop="deleteImage"
    >
<!--      <i id="deleteBtn" class="fa fa-trash"/>-->
        <font-awesome-icon icon="trash" :title="$t('common.remove')"/>
    </div>
    <div 
      v-if="showDownloadButton" 
      class="rotate-button" 
      @click.stop="downloadImage"
    >
      <font-awesome-icon icon="download" :title="$t('common.download')"/>
    </div>
    <div v-if="rotationAngle !== 0 && !saveDisabled" class="rotate-button" @click.stop="saveRotation">
      <font-awesome-icon icon="save" :title="$t('common.save')"/>
    </div>
    <div
      v-else
      class="nopads"
      style="width: 1.7em !important;"
    />
  </div>
</template>

<script>
import { downloadHelper } from '../mixins/DownloadMixin'

export default {
    name: 'RotateImageButtons',
    mixins: [downloadHelper],
    props: {
        imageContainerId: {
            type: String,
            default: null,
            required: false
        },
        controlSize: {
            type: String,
            default: 'md'
        },
        showDeleteButton: {
            type: Boolean,
            default: false
        },
        showDownloadButton: {
            type: Boolean,
            default: true
        },
        saveDisabled: {
            type: Boolean,
            default: false
        },
        photoUrl: {
            type: String,
            default: null
        },
        photoId: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            rotationAngle: 0
        }
    },
    watch: {
        rotationAngle() {
            this.rotateImage()
        }
    },
    methods: {
        rotateRight() {
            this.rotationAngle = (this.rotationAngle + 90) % 360
        },
        rotateLeft() {
            this.rotationAngle = (this.rotationAngle - 90 + 360) % 360
        },
        deleteImage() {
            this.$emit('deleteImage')
        },
        rotateImage() {
            const img = document.getElementById(this.imageContainerId);
            if (img) {
                img.style.transform = `rotate(${this.rotationAngle}deg)`;
                if (this.rotationAngle % 180 !== 0) {
                    const containerHeight = img.parentElement.clientHeight
                    const containerWidth = img.parentElement.clientWidth
                    const imgHeight = img.clientHeight
                    const imgWidth = img.clientWidth
                    const scale = Math.min(containerHeight / imgWidth, containerWidth / imgHeight)
                    img.style.transform += ` scale(${scale})`
                }
            }
        },
        saveRotation() {
            if (this.rotationAngle !== 0) {
                this.$emit('saveClicked', this.rotationAngle)
            }
        },
        resetRotation() {
            this.rotationAngle = 0
        },
        downloadImage() {
            if (this.photoUrl) {
                this.$emit('downloadImage', { url: this.photoUrl, id: this.photoId })
            }
        }
    }
}
</script>
<style scoped>
.rotate-button-container {
    display: flex;
    width: 100%;
    gap: 5px;
    top: 5px;
    z-index: 2;
    position: absolute;
    justify-content: center;
}
.sm {
    gap: 0;
}
.sm button {
    transform: scale(0.7);
}
.rotate-button {
    background: rgba(49, 49, 49, 0.75);
    border: 1px solid rgba(49,49,49,0.75);
    height: 1.6em;
    width: 1.6em;
    border-radius: .8em;
    text-align: center;
    color: #BEFF41;
    line-height: 1.6em;
    vertical-align: center;
    cursor: pointer;
    margin-left: .2em;
    margin-right: .2em;
}
</style>
